<h2 class="av-metric-card__title">{{ titleKey() | translate }}</h2>
<p class="av-metric-hint m-0">{{ hintKey() | translate }}</p>
@if (displayRows().length === 0) {
  <av-empty-state icon="inbox" [titleKey]="emptyKey()" />
} @else {
  <div class="av-top-table__body" [style.--av-top-rows]="capacity">
    <!-- table-sort-check: ignore (ranked by the backend) -->
    <table
      mat-table
      class="av-top-table__table"
      [dataSource]="displayRows()"
      [trackBy]="trackRow"
      [attr.aria-label]="titleKey() | translate"
    >
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef scope="col">{{ nameColumnKey() | translate }}</th>
        <td
          mat-cell
          *matCellDef="let row"
          class="av-top-table__name"
          [attr.title]="row.name || null"
        >
          @if (row.link; as link) {
            <a
              class="av-top-table__link"
              [routerLink]="link.path"
              [queryParams]="link.queryParams"
              [attr.aria-label]="linkLabelKey() | translate: { name: row.name }"
            >
              {{ row.name || ('shared.general.labels.na' | translate) }}
            </a>
          } @else {
            {{ row.name || ('shared.general.labels.na' | translate) }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="count">
        <th mat-header-cell *matHeaderCellDef scope="col" class="text-end">
          {{ countColumnKey() | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="av-top-table__count">
          <span class="d-flex align-items-center justify-content-end gap-2">
            <span class="av-top-table__track" aria-hidden="true">
              <span class="av-value-bar" [style.width.%]="row.percent"></span>
            </span>
            <span class="av-top-table__value av-value-text">{{
              row.count | number: '1.0-0' : language()
            }}</span>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
}
